import React from 'react'
import Breadcrumbs, { IBreadcrumb } from '../components/Breadcrumbs'
import Page from './components/Page'
import ItemsBasePage from '../features/items/ItemsBasePage'
import ProtectedPage from '../features/router/ProtectedPage'
import VerifyItem from './components/VerifyItem'

function InventoryPrivatePage() {

    /**
     * Breadcrumbs
     */
    const breadcrumbs: IBreadcrumb[] = [
        {
            title: "Home",
            link: "/"
        },
        {
            title: "Inventory",
        }
    ]

    return(
        <Page>
            <div className="inventory-page-container content-section-wrapper page-container-wrapper">
                
                <div className="page-container-head-box">
                    <div className="content-of-page-container-head-box">
                        <h1>Inventory</h1>

                        <Breadcrumbs breadcrumbs={breadcrumbs} />
                    </div>
                </div>

                <div className="inventory-list">
                    <ItemsBasePage isInventoryPage />
                </div>

            </div>
        </Page>
    )
}

function InventoryPublicPage(){

    return(
        <Page>
            <VerifyItem />
        </Page>
    )
}

export default function Inventory() {

    return(
        <ProtectedPage isAdminOnly={false} redirectIfUnauthorized={false} CustomErrorPage={InventoryPublicPage}>
            <InventoryPrivatePage />
        </ProtectedPage>
    )
}